import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

/* Formulario de REGISTRO / alta en el Canal Pilar Domínguez–MEFIR.
   Estilo de marca (mismo blanco/mint del login y el onboarding).

   CONECTADO A LA FICHA DE CLIENTE REAL (UserBase en backend/server.py y
   pages/ClientNewProfile.jsx). Recoge el bloque de IDENTIDAD tal como lo
   guarda la ficha:
     nombre · primer_apellido · segundo_apellido (SEPARADOS) · dni (NIF/NIE
     validado) · fecha_nacimiento · sexo (M/F/Otro) · email · telefono.
   Campos que completa DESPUÉS administración (operativa interna, no en el
   alta pública): sede, cuota/membresía, forma de pago/SEPA.

   El enganche real (POST /auth/register con este payload) lo cierra
   Videos-Backend; aquí está la cara + validación de cliente. */

const TEAL = '#2C6675';
const TEAL2 = '#3C8696';

const S = {
  wrap: {
    minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start',
    background: 'radial-gradient(130% 70% at 50% 0%,#E1F4EF 0%,#EAF6F4 55%)',
    fontFamily: "'Montserrat', system-ui, sans-serif", padding: '38px 18px 48px',
  },
  logos: { display: 'flex', alignItems: 'center', gap: 18, marginBottom: 20 },
  card: {
    background: '#fff', borderRadius: 22, boxShadow: '0 18px 50px rgba(44,107,118,.16)',
    width: '100%', maxWidth: 480, padding: '30px 28px 28px', boxSizing: 'border-box',
  },
  title: { margin: '0 0 4px', fontSize: 24, color: '#16323a', fontWeight: 800, textAlign: 'center' },
  desc: { margin: '0 0 22px', color: '#33474d', fontSize: 14.5, textAlign: 'center' },
  label: { fontWeight: 700, fontSize: 13, color: '#16323a', display: 'block' },
  input: (err) => ({
    width: '100%', height: 46, borderRadius: 12, border: `1px solid ${err ? '#e3a6a3' : '#dbe6e7'}`, padding: '0 14px',
    fontSize: 15, outline: 'none', boxSizing: 'border-box', margin: '6px 0 4px',
    fontFamily: "'Montserrat', system-ui, sans-serif",
  }),
  err: { color: '#d9534f', fontSize: 12, margin: '0 0 10px' },
  gap: { marginBottom: 10 },
  row: { display: 'flex', gap: 12 },
  btn: (dis) => ({
    height: 48, borderRadius: 12, border: 'none', width: '100%', cursor: dis ? 'default' : 'pointer',
    fontWeight: 800, fontSize: 15.5, fontFamily: "'Montserrat', system-ui, sans-serif", marginTop: 8,
    background: dis ? '#cfe0e1' : `linear-gradient(135deg,${TEAL2},${TEAL})`, color: '#fff',
  }),
  link: { background: 'none', border: 'none', color: TEAL, fontSize: 13.5, cursor: 'pointer', textDecoration: 'underline', fontFamily: 'inherit' },
};

const Req = () => <span style={{ color: '#c0564f' }}> *</span>;

const Logos = () => (
  <div style={S.logos}>
    <img src="/logo-pd.png" alt="Pilar Domínguez" style={{ height: 38, width: 'auto' }} />
    <span style={{ width: 1, height: 32, background: 'rgba(44,107,118,.3)' }} />
    <img src="/logo-mefir-trans.png" alt="Instituto MEFIR" style={{ height: 34, width: 'auto' }} />
  </div>
);

// Validación NIF/NIE con letra de control — copiada literal de la ficha (ClientNewProfile.jsx).
function validarDNI(dni) {
  if (!dni) return false;
  const validChars = 'TRWAGMYFPDXBNJZSQVHLCKE';
  const nifRexp = /^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKE]{1}$/i;
  const nieRexp = /^[XYZ]{1}[0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKE]{1}$/i;
  const str = dni.toString().toUpperCase().replace(/\s/g, '');
  if (!nifRexp.test(str) && !nieRexp.test(str)) return false;
  const nieToNum = str.replace(/^[X]/, '0').replace(/^[Y]/, '1').replace(/^[Z]/, '2');
  const letter = str.substr(-1);
  const charIndex = parseInt(nieToNum.substr(0, 8), 10) % 23;
  return validChars.charAt(charIndex) === letter;
}

const _debiles = /^(?:1234\d*|12345678|123456789|0000+|1111+|password|passw0rd|contrasena|contraseña|qwerty|abcdef|admin\d*)$/i;
const esMenor = (fnac) => {
  if (!fnac) return false;
  const h = new Date(); const n = new Date(fnac);
  let e = h.getFullYear() - n.getFullYear();
  const m = h.getMonth() - n.getMonth();
  if (m < 0 || (m === 0 && h.getDate() < n.getDate())) e--;
  return e < 18;
};

export default function RegistroCanal({ onListo = () => {} }) {
  const { t } = useTranslation('auth');
  const _emailInicial = (() => { try { return new URLSearchParams(window.location.search).get('email') || ''; } catch (e) { return ''; } })();
  const [f, setF] = useState({
    nombre: '', primer_apellido: '', segundo_apellido: '', dni: '',
    fecha_nacimiento: '', sexo: '', email: _emailInicial, telefono: '', pw1: '', pw2: '',
  });
  const [acepta, setAcepta] = useState(false);
  const [tocado, setTocado] = useState({});
  const [hecho, setHecho] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const marca = (k) => () => setTocado({ ...tocado, [k]: true });

  const dniOk = validarDNI(f.dni);
  const emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(f.email);
  const telOk = f.telefono.replace(/\s/g, '').length >= 9;
  const reglasPw = [
    { ok: f.pw1.length >= 8, txt: t('comun.reglaMin8') },
    { ok: /[a-z]/.test(f.pw1) && /[A-Z]/.test(f.pw1), txt: t('comun.reglaMayusMinus') },
    { ok: /\d/.test(f.pw1), txt: t('comun.reglaNumero') },
    { ok: f.pw1.length > 0 && !_debiles.test(f.pw1), txt: t('comun.reglaTipica') },
  ];
  const pwFuerte = reglasPw.every(r => r.ok);
  const menor = esMenor(f.fecha_nacimiento);

  const listo = f.nombre.trim() && f.primer_apellido.trim() && f.segundo_apellido.trim()
    && dniOk && f.fecha_nacimiento && f.sexo && emailOk && telOk && pwFuerte && f.pw1 === f.pw2 && acepta;

  if (hecho) {
    return (
      <div style={S.wrap}>
        <Logos />
        <div style={{ ...S.card, textAlign: 'center' }}>
          <div style={{ width: 64, height: 64, borderRadius: '50%', background: 'rgba(60,134,150,.12)', display: 'grid', placeItems: 'center', margin: '4px auto 16px' }}>
            <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke={TEAL} strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5" /></svg>
          </div>
          <h1 style={S.title}>{t('registro.solicitudEnviada')}</h1>
          <p style={S.desc}>{t('registro.solicitudSub')}</p>
          <button style={S.btn(false)} onClick={onListo}>{t('comun.irLogin')}</button>
        </div>
      </div>
    );
  }

  return (
    <div style={S.wrap}>
      <Logos />
      <div style={S.card}>
        <h1 style={S.title}>{t('registro.titulo')}</h1>
        <p style={S.desc}>{t('registro.sub')}</p>

        {/* Nombre */}
        <label style={S.label}>{t('comun.nombre')}<Req /></label>
        <input value={f.nombre} onChange={set('nombre')} placeholder={t('comun.tuNombrePlaceholder')} style={S.input(false)} />
        <div style={S.gap} />

        {/* Dos apellidos SEPARADOS (como la ficha) */}
        <div style={S.row}>
          <div style={{ flex: 1 }}>
            <label style={S.label}>{t('comun.primerApellido')}<Req /></label>
            <input value={f.primer_apellido} onChange={set('primer_apellido')} placeholder={t('comun.primerApellido')} style={S.input(false)} />
          </div>
          <div style={{ flex: 1 }}>
            <label style={S.label}>{t('comun.segundoApellido')}<Req /></label>
            <input value={f.segundo_apellido} onChange={set('segundo_apellido')} placeholder={t('comun.segundoApellido')} style={S.input(false)} />
          </div>
        </div>
        <div style={S.gap} />

        {/* DNI/NIE con validación real */}
        <label style={S.label}>{t('comun.dniNie')}<Req /></label>
        <input value={f.dni} onChange={set('dni')} onBlur={marca('dni')} placeholder="12345678Z" style={S.input(tocado.dni && f.dni && !dniOk)} />
        {tocado.dni && f.dni && !dniOk ? <p style={S.err}>{t('registro.dniInvalido')}</p> : <div style={S.gap} />}

        {/* Fecha de nacimiento + Sexo */}
        <div style={S.row}>
          <div style={{ flex: 1 }}>
            <label style={S.label}>{t('comun.fechaNacimiento')}<Req /></label>
            <input type="date" value={f.fecha_nacimiento} onChange={set('fecha_nacimiento')} style={S.input(false)} />
          </div>
          <div style={{ flex: 1 }}>
            <label style={S.label}>{t('comun.sexo')}<Req /></label>
            <select value={f.sexo} onChange={set('sexo')} style={{ ...S.input(false), padding: '0 10px' }}>
              <option value="">{t('comun.selecciona')}</option>
              <option value="M">{t('comun.hombre')}</option>
              <option value="F">{t('comun.mujer')}</option>
              <option value="Otro">{t('comun.otro')}</option>
            </select>
          </div>
        </div>
        {menor
          ? <p style={{ ...S.err, color: '#8a6d3b' }}>{t('registro.menorEdad')}</p>
          : <div style={S.gap} />}

        {/* Email */}
        <label style={S.label}>{t('comun.email')}<Req /></label>
        <input type="email" value={f.email} onChange={set('email')} onBlur={marca('email')} placeholder={t('comun.emailPlaceholder')} style={S.input(tocado.email && f.email && !emailOk)} />
        {tocado.email && f.email && !emailOk ? <p style={S.err}>{t('comun.emailInvalido')}</p> : <div style={S.gap} />}

        {/* Teléfono — OBLIGATORIO */}
        <label style={S.label}>{t('comun.telefono')}<Req /></label>
        <input value={f.telefono} onChange={set('telefono')} onBlur={marca('telefono')} placeholder="600 000 000" style={S.input(tocado.telefono && f.telefono && !telOk)} />
        {tocado.telefono && f.telefono && !telOk ? <p style={S.err}>{t('registro.telefonoInvalido')}</p> : <div style={S.gap} />}

        {/* Contraseña */}
        <label style={S.label}>{t('comun.password')}<Req /></label>
        <input type="password" value={f.pw1} onChange={set('pw1')} placeholder={t('comun.passwordSeguraPlaceholder')} style={S.input(false)} />
        {f.pw1.length > 0 && (
          <div style={{ margin: '6px 0 10px', display: 'flex', flexDirection: 'column', gap: 4 }}>
            {reglasPw.map((r, i) => (
              <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 7, fontSize: 12.5, color: r.ok ? '#2f7d5a' : '#8a7a5a' }}>
                <span style={{ width: 15, height: 15, borderRadius: '50%', flexShrink: 0, display: 'grid', placeItems: 'center', background: r.ok ? '#2f7d5a' : '#e2d9c6', color: '#fff', fontSize: 10 }}>{r.ok ? '✓' : ''}</span>
                {r.txt}
              </div>
            ))}
          </div>
        )}
        {f.pw1.length === 0 && <div style={S.gap} />}

        {/* Repetir */}
        <label style={S.label}>{t('comun.repitePassword')}<Req /></label>
        <input type="password" value={f.pw2} onChange={set('pw2')} placeholder={t('comun.repitePlaceholder')} style={S.input(f.pw2 && f.pw1 !== f.pw2)} />
        {f.pw2 && f.pw1 !== f.pw2 ? <p style={S.err}>{t('comun.noCoinciden')}</p> : <div style={S.gap} />}

        {/* Consentimiento */}
        <label style={{ display: 'flex', gap: 10, alignItems: 'flex-start', margin: '6px 0 4px', cursor: 'pointer', fontSize: 13.5, color: '#16323a' }}>
          <input type="checkbox" checked={acepta} onChange={e => setAcepta(e.target.checked)} style={{ marginTop: 3, width: 18, height: 18, accentColor: TEAL }} />
          <span>{t('registro.consent1')}<b>{t('registro.consentStrong')}</b>{t('registro.consent2')}</span>
        </label>

        <button style={S.btn(!listo)} disabled={!listo} onClick={() => setHecho(true)}>{t('registro.crearCuenta')}</button>

        <p style={{ textAlign: 'center', marginTop: 16, fontSize: 13.5, color: '#33474d' }}>
          {t('registro.yaTienesCuenta')} <button style={S.link} onClick={onListo}>{t('registro.iniciaSesion')}</button>
        </p>
      </div>
    </div>
  );
}
